import {Logger, Utils} from 'neo-common';

const key_ClientHostType = 'ClientHostType';
const key_RealityCheckType = 'RealityCheckType';
const key_GameClientCallsRealityCheckUrls = 'GameClientCallsRealityCheckUrls';


export abstract class GameDefinitionBase {
    private _definition: Object;

    constructor(definition: Object) {
        if (DEBUG) {
            if (Utils.isNullOrUndefined(definition)) {
                Logger.errorGroup('GameDefinition', `Parameter "definition" must not be null!`);
            }
        }

        this._definition = Utils.valueOrDefault(definition, {});
    }

    public getRaw(): Object {
        return this._definition;
    }

    protected getValue<T>(key: string, defaultValue: T): T {
        let result = defaultValue;
        if (this._definition && this._definition.hasOwnProperty(key)) {
            result = this._definition[key];
            if (!Utils.isNullOrUndefined(result)) {
                let resultValueType = typeof result;
                let expectedValueType = typeof defaultValue;

                if (resultValueType !== expectedValueType) {
                    if (DEBUG) {
                        Logger.errorGroup('GameDefinition',
                            `Incompatible value type (${resultValueType}) of key "${key}" from definition file, ` +
                            `expected value type (${expectedValueType}), returning default value '${defaultValue}'`);
                    }

                    result = defaultValue;
                }
            }
        }

        return result;
    }

    /**
     * @property ClientHostType - type name for client host, eg.(Default, Desktop, Trinity, ...)
     */
    public get ClientHostType(): string {
        return this.getValue(key_ClientHostType, 'Default');
    }

    /**
     * @property RealityCheckType - type name for reality check implementation, if not specified, value 'Default' is used.
     */
    public get RealityCheckType(): string {
        return this.getValue(key_RealityCheckType, 'Default');
    }

    /**
     * @property GameClientCallsRealityCheckUrls - boolean whenever GameClient should call player's reality checks urls (close/reset) or not.
     * @constructor
     */
    public get GameClientCallsRealityCheckUrls(): boolean {
        return this.getValue(key_GameClientCallsRealityCheckUrls, true);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/GameEngine/GameDefinitionBase.ts
 **/